import { render } from "./TicketBuyers.vue?vue&type=template&id=501f4fba&scoped=true"
import script from "./TicketBuyers.vue?vue&type=script&lang=js"
export * from "./TicketBuyers.vue?vue&type=script&lang=js"

import "./TicketBuyers.vue?vue&type=style&index=0&id=501f4fba&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501f4fba"]])

export default __exports__